import { baseApi } from './base';
import { SearchResponse } from '../types/response';
import { SearchRequestOptions } from '../types/request';
import { Tag } from './base';
import {
    KnowledgeBaseCollection,
    CreateKnowledgeBaseCollectionDto,
    UpdateKnowledgeBaseCollectionDto,
    ReprocessDocumentsDto
} from '../models/knowledge-base-collection.model';

export type ListCollectionsFilterQuery = {
    establishmentId?: string;
};

export const knowledgeBaseApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        // Collections
        listKnowledgeBaseCollections: builder.query<SearchResponse<KnowledgeBaseCollection>, { query?: ListCollectionsFilterQuery, options?: SearchRequestOptions }>({
            query: (body) => ({
                url: '/admin/knowledge-base/collections/search',
                method: 'POST',
                body,
            }),
            providesTags: (result) =>
                result ? [...result.items.map(({ _id }) => ({ type: Tag.KNOWLEDGE_BASE_COLLECTION, id: _id })), { type: Tag.KNOWLEDGE_BASE_COLLECTION, id: 'LIST' }] : [{ type: Tag.KNOWLEDGE_BASE_COLLECTION, id: 'LIST' }],
        }),
        getKnowledgeBaseCollection: builder.query<KnowledgeBaseCollection, string>({
            query: (id) => `/admin/knowledge-base/collections/${id}`,
            providesTags: (_result, _error, id) => [{ type: Tag.KNOWLEDGE_BASE_COLLECTION, id }],
        }),
        createKnowledgeBaseCollection: builder.mutation<KnowledgeBaseCollection, CreateKnowledgeBaseCollectionDto>({
            query: (body) => ({
                url: '/admin/knowledge-base/collections',
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: Tag.KNOWLEDGE_BASE_COLLECTION, id: 'LIST' }],
        }),
        updateKnowledgeBaseCollection: builder.mutation<KnowledgeBaseCollection, { id: string; body: UpdateKnowledgeBaseCollectionDto }>({
            query: ({ id, body }) => ({
                url: `/admin/knowledge-base/collections/${id}`,
                method: 'PATCH',
                body,
            }),
            invalidatesTags: (_result, _error, { id }) => [{ type: Tag.KNOWLEDGE_BASE_COLLECTION, id }],
        }),
        deleteKnowledgeBaseCollection: builder.mutation<{ message: string }, string>({
            query: (id) => ({
                url: `/admin/knowledge-base/collections/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: [{ type: Tag.KNOWLEDGE_BASE_COLLECTION, id: 'LIST' }],
        }),
        reprocessKnowledgeBaseDocuments: builder.mutation<{ message: string }, { collectionId: string; body: ReprocessDocumentsDto }>({
            query: ({ collectionId, body }) => ({
                url: `/admin/knowledge-base/collections/${collectionId}/documents/reprocess`,
                method: 'POST',
                body,
            }),
            invalidatesTags: (_result, _error, { collectionId }) => [{ type: Tag.KNOWLEDGE_BASE_COLLECTION, id: collectionId }],
        })
    }),
    overrideExisting: false,
}); 